import { ContactsState } from './types'
import { AsyncStateStatus } from '../root.types'
import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit'

const initialState: ContactsState = {
    request: {
        status: AsyncStateStatus.INITIAL,
        data: []
    },
}

export const contactsSlice = createSlice({
    name: '@contacts',
    initialState,
    reducers: {
        contactsRequest: (state: Draft<ContactsState>) => {
            state.request.status = AsyncStateStatus.LOADING
        },
        contactsSuccess: (state: Draft<ContactsState>, action: PayloadAction<{ data: any } >) => {
            state.request.status = AsyncStateStatus.SUCCESS
            state.request.data = action.payload.data
        },
        contactsFailure: (state: Draft<ContactsState>) => {
            state.request.status = AsyncStateStatus.FAILURE
        },
    }
})

export const ContactsActions = contactsSlice.actions

export default contactsSlice.reducer
